// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { listCatalogAwards, listMyAwards, getShowcaseAwards, setShowcaseAwards } from '@/services/awards';
import { toast } from '@/hooks/use-toast';

export default function AwardsShowcasePicker() {
  const [catalog, setCatalog] = useState<any[]>([]);
  const [earned, setEarned] = useState<Set<string>>(new Set());
  const [selected, setSelected] = useState<string[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [c, e, s] = await Promise.all([listCatalogAwards(), listMyAwards(), getShowcaseAwards()]);
        setCatalog(c);
        setEarned(new Set(e));
        const slots = (s || []).sort((a: any, b: any) => a.slot - b.slot).map((x: any) => x.award_id);
        setSelected(slots);
      } catch (e: any) {
        console.error(e);
      }
    })();
  }, []);

  const toggle = (id: string) => {
    const next = selected.includes(id)
      ? selected.filter(x => x !== id)
      : selected.length < 3 ? [...selected, id] : selected;
    setSelected(next);
  };

  const save = async () => {
    setSaving(true);
    try {
      await setShowcaseAwards(selected);
      toast({ title: 'Showcase updated' });
    } catch (e: any) {
      toast({ title: 'Error', description: e.message || 'Failed to save', variant: 'destructive' });
    } finally { setSaving(false); }
  };

  return (
    <Card className="bg-white/5 border-white/10">
      <CardHeader className="pb-2">
        <CardTitle className="text-base text-white">Showcase Awards (up to 3)</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-sm text-white/80">Pick up to three earned awards to show on your profile.</div>
        <ScrollArea className="h-56 border border-white/10 rounded-xl p-2 bg-white/5">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {catalog.map(a => (
              <button key={a.id} disabled={!earned.has(a.id)} onClick={() => toggle(a.id)} className={`rounded-lg p-2 text-left ${selected.includes(a.id) ? 'bg-emerald-500/10 border border-emerald-400/30' : 'border border-white/10 hover:bg-white/5'} ${!earned.has(a.id) ? 'opacity-50 cursor-not-allowed' : ''} text-white`}>
                <div className="text-sm text-white">{a.name}</div>
                {a.description && <div className="text-xs text-white/60 line-clamp-2">{a.description}</div>}
              </button>
            ))}
          </div>
        </ScrollArea>
        <div className="flex justify-end">
          <Button onClick={save} disabled={saving} className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white hover:from-emerald-400 hover:to-teal-400">Save</Button>
        </div>
      </CardContent>
    </Card>
  );
}


